import { useContext } from "react";
import styled from "styled-components";
import { dateFormat } from "../helper";
import { tableStore } from "../store/table";
import Grid from "./ui/Grid";
import SummaryItem from "./ui/SummaryItem";

const Wrapper = styled.div`
  background: #5f5f5f;
  padding: 20px 30px;
  color: white;
`;

const Title = styled.h3`
  color: white;
  font-size: 14px;
  margin: 0;
  text-transform: uppercase;
`;

const Summary = () => {
  const { table } = useContext(tableStore);

  const activePackage = table.packages
    ? Object.values(table.packages)
        .filter((item) => {
          return item.id === table.package;
        })
        .filter(Boolean)
        .shift()
    : null;

  return (
    <Wrapper>
      <Title>Summary</Title>
      <Grid>
        <SummaryItem label="Date" value={dateFormat(table.date)} />
        <SummaryItem label="Time" value={table.time} />
        <SummaryItem label="Guests" value={table.numPeople} />
        <SummaryItem
          label="Booking Type"
          value={table?.bookingTypeTitle}
        />
      </Grid>
      {activePackage && (
        <Grid>
          <SummaryItem
            label="Additional Packages"
            value={activePackage.title}
          />
        </Grid>
      )}
    </Wrapper>
  );
};

export default Summary;
